import React from "react";
import {
  Svg,
  Line,
  Polyline,
  Polygon,
  Path,
  Rect,
  Circle,
  Ellipse,
  Text,
  Tspan,
  G,
  Stop,
  ClipPath,
  LinearGradient,
  RadialGradient,
} from "@react-pdf/renderer";

export const Lune = ({color} : {color: string}) => {
  // @ts-ignore
  return (<Svg id="Calque_1" data-name="Calque 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 78.41 82.2">
  <G fill={color}>
    <Path d="M77.63,55.88c-.82-.85-2.07-1.09-3.14-.62-3.92,1.73-8.08,2.61-12.38,2.61-16.92,0-30.69-13.77-30.69-30.69,0-8.54,3.43-16.48,9.66-22.34.85-.8,1.12-2.06.66-3.13-.46-1.08-1.55-1.76-2.71-1.7C17.14,1.11,0,19.15,0,41.08s18.45,41.13,41.13,41.13c15.88,0,30.05-8.88,37-23.16.51-1.06.31-2.32-.5-3.17Z"/>
  </G>
</Svg>
);
};

export default Lune;
